// Set by the PDF download route when a signed-out person follows an approval email link.
const COOKIE = 'timecone_return_to';
const RETURN_PATH = /^\/api\/reports\/timesheets\/[a-f0-9]{24}\/pdf$/;

/** The path to go back to after sign-in, read once and then forgotten. */
export const takeReturnTo = () => {
  const entry = document.cookie.split('; ').find(part => part.startsWith(`${COOKIE}=`));
  if (!entry) return null;
  document.cookie = `${COOKIE}=; Path=/; Max-Age=0; SameSite=Lax`;
  let path;
  try {
    path = decodeURIComponent(entry.slice(COOKIE.length + 1));
  } catch (error) {
    return null;
  }
  return RETURN_PATH.test(path) ? path : null;
};
